import { Env } from './env';

export namespace SessionCookie {
  export const AuthHeaderPrefix = 'Session ';
  export const CsrfHeaderName = 'Csrf-Token';

  export const toAuthHeader = (sessionCookie: string): string => `${AuthHeaderPrefix}${sessionCookie}`;

  export const extractFromAuthHeader = (authHeader: string | undefined): string | undefined => {
    if (!authHeader?.startsWith(AuthHeaderPrefix)) return undefined;
    return authHeader.slice(AuthHeaderPrefix.length);
  };

  export const extractBearerToken = (authHeader: string | undefined): string | undefined => {
    if (!authHeader?.startsWith('Bearer ')) return undefined;
    return authHeader.slice('Bearer '.length);
  };

  export const getCookieDomain = (): string | undefined => {
    const host = Env.Var.QantDomain.base.root.split(':')[0];
    if (!host || host === 'localhost') return undefined;
    return host;
  };

  export const getSessionCookie = (cookies: Record<string, unknown> | undefined): string | undefined => {
    const value = cookies?.[Env.Var.Cookie.SessionId];
    return typeof value === 'string' && value ? value : undefined;
  };

  export const getCsrfCookie = (cookies: Record<string, unknown> | undefined): string | undefined => {
    const value = cookies?.[Env.Var.Cookie.SessionCsrfToken];
    return typeof value === 'string' && value ? value : undefined;
  };

  export const isUnsafeMethod = (method: string): boolean => !['GET', 'HEAD', 'OPTIONS'].includes(method.toUpperCase());

  export const parseCookieValue = (cookieHeader: string, name: string): string | undefined => {
    const segments = cookieHeader.split(';');
    for (const segment of segments) {
      const [rawKey, ...rawValue] = segment.trim().split('=');
      if (rawKey !== name) continue;
      const value = rawValue.join('=');
      return value ? decodeURIComponent(value) : undefined;
    }
    return undefined;
  };
}
